module.exports = __webpack_public_path__ + "img/moGaoKu6.bd4145f1.png";